import type { CSSProperties } from 'react';
import { VariantType } from 'notistack';

export const NOTIFICATION_TYPES = {
  ERROR: 'error' as VariantType,
  SUCCESS: 'success' as VariantType,
  WARNING: 'warning' as VariantType,
  INFO: 'info' as VariantType,
} as const;

export type TNotificationActionButton = {
  displayLabel: string;
  onClick: () => void;
};

export type TNotificationItem = {
  message: string;
  type: VariantType;
  buttonLeft?: TNotificationActionButton;
  buttonRight?: TNotificationActionButton;
  /** When omitted: false without buttons, true when any button is set */
  persist?: boolean;
  snackbarStyle?: CSSProperties;
};

export type TNotificationState = {
  notification: TNotificationItem | null;
};
